import './Footer.css';
import { FaInstagram, FaTiktok, FaTwitter } from 'react-icons/fa';
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <h2 className="footer-logo">CTO</h2>
            <p>
              Crypto Trail Officer (CTO), kripto para piyasalarını takip etmek, analiz etmek ve 
              yönetmek için geliştirilen kapsamlı bir platformdur.
            </p>
            <div className="social-links">
              <a href="https://x.com/cto_ai_app" target="_blank"  rel="noreferrer" aria-label="Twitter"><FaTwitter /></a>
              <a href="https://www.instagram.com/cto_ai_app/" target="_blank"  rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.tiktok.com/@cto.ai" target="_blank"  rel="noreferrer" aria-label="Tiktok"><FaTiktok /></a>
            </div>
          </div>
          
          <div className="footer-links">
            <h3>Bağlantılar</h3>
            <ul>
              <li><a href="#features">Özellikler</a></li>
              <li><a href="#ai">CTO AI</a></li>
              <li><a href="#tracking">Piyasa Takibi</a></li>
              <li><a href="#download">İndirme</a></li>
            </ul>
          </div>
          
          <div className="footer-links">
            <h3>Yasal</h3>
            <ul>
              <li><Link to="/privacy">Gizlilik Politikası</Link></li>
              <li><Link to="/tos">Kullanım Koşulları</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CTO (Crypto Trail Officer). Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 